import React, { Component } from 'react';
import { connect } from 'react-redux';
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import './ExternalDataHistoryListComponent.css';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Box,
  Grid,
} from '@material-ui/core';
import { setSystemLodingFLg } from '../../actions/CommonAction';
import {
  setExNowPage,
  setExternalDataSendHistoryList,
  // createExDownloadFile,
  searchExPaging,
  executeExFileDownload,
} from '../../actions/ExternalDataHistoryAction';
import {
  DISP_COUNT_LIMIT,
  EXTERNALDATA_RESULTPAGING,
} from '../../../common/const';
import MyIcon from '../common/MyIcon';

class ExternalDataSendHistoryListComponent extends Component {
  /**
   * ページ選択
   * @param {string} page
   */
  changePage = async (page) => {
    const {
      setSystemLodingFlgAct,
      setExNowPageAct,
      setExternalDataSendHistoryListAct,
      searchExPagingAct,
    } = this.props;
    setExNowPageAct(page);
    // 検索API呼出し
    setSystemLodingFlgAct(true);
    const response = await searchExPagingAct(page);
    setSystemLodingFlgAct(false);
    setExternalDataSendHistoryListAct(response);
  }

  /**
   * ダウンロードボタン押下
   */
  onClickCreateDownloadFile = async () => {
    const {
      setSystemLodingFlgAct,
      executeExFileDownloadAct,
    } = this.props;
    setSystemLodingFlgAct(true);
    await executeExFileDownloadAct();
    setSystemLodingFlgAct(false);
  }

  render() {
    const {
      externalDataSendHistoryList,
      exNowPage,
      exLimitMessage,
    } = this.props;
    // ページングの表示処理 ここから
    let pagingArea = null;
    let totalCount = null;

    // 全体件数が最大取得件数以上の場合、全体件数を最大取得件数に設定
    if (externalDataSendHistoryList
      && externalDataSendHistoryList.all_count) {
      totalCount = externalDataSendHistoryList.all_count < DISP_COUNT_LIMIT.EXTERNALDATA_HISTORY
        ? externalDataSendHistoryList.all_count : DISP_COUNT_LIMIT.EXTERNALDATA_HISTORY;
    }

    // 全体件数が最大表示件数以下の場合、ページング表示処理を実施
    if (externalDataSendHistoryList
      && totalCount) {
      const maxPageCount = totalCount === 0
        ? 1
        : Math.ceil(totalCount / EXTERNALDATA_RESULTPAGING.PAGE_RECORD_COUNT);

      pagingArea = (
        <Pagination
          variant="outlined"
          count={maxPageCount}
          onChange={(e, page) => this.changePage(page)}
          page={exNowPage}
          className="pagingArea"
          renderItem={(item) => (
            <PaginationItem
              {...item}
              disabled={
                item.page === exNowPage
                || (item.type === 'next' && exNowPage === maxPageCount)
                || (item.type === 'previous' && exNowPage === 1)
              }
              className={`${item.page === exNowPage ? 'customPaginationItem' : ''}`}
            />
          )}
        />
      );
    }
    // ページングの表示処理 ここまで
    // 表示件数作成
    const dispCountStart = (exNowPage - 1) * EXTERNALDATA_RESULTPAGING.PAGE_RECORD_COUNT + 1;
    const dispCountEnd = (externalDataSendHistoryList
      && externalDataSendHistoryList.result_count
      && totalCount
      && totalCount <= DISP_COUNT_LIMIT.EXTERNALDATA_HISTORY)
      ? (exNowPage - 1) * EXTERNALDATA_RESULTPAGING.PAGE_RECORD_COUNT
        + Number(externalDataSendHistoryList.result_count)
      : null;
    const dispResultCount = dispCountEnd ? `${dispCountStart}-${dispCountEnd}` : 0;

    // 全体件数
    const allCount = (externalDataSendHistoryList && totalCount)
      ? Number(totalCount).toLocaleString()
      : 0;

    return (
      <div className="externalDataHistoryList">
        <div className="content">
          <div className="resultCount">
            <span className="searchResult">{dispResultCount}</span>
            {` / ${allCount}件`}
          </div>
          <Grid className="summary-page">
            {pagingArea}
            {externalDataSendHistoryList && externalDataSendHistoryList.result_count > 0
            && (
            <Button
              variant="contained"
              color="secondary"
              onClick={this.onClickCreateDownloadFile}
              startIcon={<MyIcon className="faceIcon" type="download" />}
              className="download"
            >
              ダウンロード
            </Button>
            )}
            {exLimitMessage
          && (
          <span className="limitMessage">{exLimitMessage}</span>
          )}

          </Grid>
          <Box className="searchResultarea">
            <div className="searchResultareaTableHead">
              <Table className="tableLayout">
                <TableHead>
                  <TableRow>
                    <TableCell className="resultTableHeader exProcessNo">処理番号</TableCell>
                    <TableCell className="resultTableHeader createDate">作成日時</TableCell>
                    <TableCell className="resultTableHeader exStatus">ステータス</TableCell>
                    <TableCell className="resultTableHeader collaboration">連携先</TableCell>
                    <TableCell className="resultTableHeader dataType">データ種別</TableCell>
                    <TableCell className="resultTableHeader targetingName">名称</TableCell>
                    <TableCell className="resultTableHeader createUser">作成ユーザID</TableCell>
                    <TableCell className="resultTableHeader dataCount">データ件数</TableCell>
                    <TableCell className="resultTableHeader linkageProcessNo">連携先：処理番号</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </div>
            <div className="productsconditionTableBody">
              <Table className="tableLayout">
                <TableBody className="searchResultareaTableBody">
                  {externalDataSendHistoryList
                    && externalDataSendHistoryList.external_history_list
                    && externalDataSendHistoryList.external_history_list.map((resultset, i) => (
                      <TableRow key={i}>
                        <TableCell className="resultTableCell exProcessNo padding">
                          {resultset.process_no}
                        </TableCell>
                        <TableCell className="resultTableCell creteDate">
                          {resultset.create_datetime}
                        </TableCell>
                        <TableCell className="resultTableCell exStatus">
                          {resultset.status}
                        </TableCell>
                        <TableCell className="resultTableCell collaboration">
                          {resultset.collaboration}
                        </TableCell>
                        <TableCell className="resultTableCell dataType">
                          {resultset.data_type}
                        </TableCell>
                        <TableCell className="resultTableCell targetingName">
                          {resultset.targeting_name}
                        </TableCell>
                        <TableCell className="resultTableCell createUser">
                          {resultset.create_user}
                        </TableCell>
                        <TableCell className="resultTableCell dataCount">
                          {resultset.data_count}
                        </TableCell>
                        <TableCell className="resultTableCell linkageProcessNo">
                          {resultset.linkage_process_no}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </div>
          </Box>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    exNowPage: state.externaldata.exNowPage,
    externalDataSendHistoryList: state.externaldata.externalDataSendHistoryList,
    exLimitMessage: state.externaldata.exLimitMessage,
  }),
  (dispatch) => ({
    setSystemLodingFlgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    searchExPagingAct: (obj) => dispatch(searchExPaging(obj)),
    setExNowPageAct: (str) => dispatch(setExNowPage(str)),
    setExternalDataSendHistoryListAct: (obj) => dispatch(setExternalDataSendHistoryList(obj)),
    executeExFileDownloadAct: () => dispatch(executeExFileDownload()),
  }),
)(ExternalDataSendHistoryListComponent);
